module.exports = ['$scope', '$timeout', 'locale', ($scope, $timeout, locale) ->
  language = if locale.isFrench() then 'fr' else 'en'
  postRequire = (r) ->
    # $timeout ensures we don't create a digest loop problem
    $timeout ->
      countries = _.map Object.keys(r.getAlpha3Codes()), (c) ->
        code: c
        name: r.getName(c, language)
      countries = countries.sort((a, b) => a.name.localeCompare(b.name))
      $scope.countries = countries

  countries = require('i18n-iso-countries')
  enCountryLabels = require('i18n-iso-countries/langs/en.json')
  frCountryLabels = require('i18n-iso-countries/langs/fr.json')

  countries.registerLocale(enCountryLabels)
  countries.registerLocale(frCountryLabels)

  postRequire(countries)

  @
]
